import { render } from "./MiniLoader.vue?vue&type=template&id=73e36ace&scoped=true"
const script = {}

import "./MiniLoader.vue?vue&type=style&index=0&id=73e36ace&scoped=true&lang=css"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e36ace"]])

export default __exports__